import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReminderNudgeV1Response } from './get-reminder-nudge-v1-response';
import { getReminderNudgeV1ResponseSchema } from './get-reminder-nudge-v1-response';

export async function getReminderNudgeV1Api(
  variantId?: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetReminderNudgeV1Response>> {
  const query = variantId ? `?variant=${encodeURIComponent(variantId)}` : '';
  return getRequest<IGetReminderNudgeV1Response>({
    path: `/reminder/nudge/v1${query}`,
    schema: getReminderNudgeV1ResponseSchema,
    options,
  });
}
